import wrapWithLayout from './wrap-with-layout';
import wrapWithProvider from './wrap-with-provider';

export const wrapRootElement = wrapWithProvider;
export const wrapPageElement = wrapWithLayout;
